'use client';

import Logo from './logo';

const FullPageLoader = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-site" data-testid="full-page-loader">
      <div className="relative flex flex-col items-center justify-center space-y-8">
        <div className="relative flex w-[280px] max-w-[70vw] animate-pulse-slow items-center justify-center">
          <Logo variant="display" />
        </div>

        <div className="text-center">
          <h2 className="mb-2 animate-fade-in-up delay-1000 text-2xl font-semibold text-black">Loading</h2>
          <div className="flex justify-center space-x-1 animate-fade-in-up delay-1200">
            <div className="h-2 w-2 animate-bounce rounded-full bg-black"></div>
            <div className="h-2 w-2 animate-bounce rounded-full bg-black delay-100"></div>
            <div className="h-2 w-2 animate-bounce rounded-full bg-black delay-200"></div>
          </div>
        </div>

        <div className="h-1 w-64 overflow-hidden rounded-full bg-black/20 animate-fade-in-up delay-1400">
          <div className="h-full animate-loading-bar bg-gradient-to-r from-[#F84F2A] via-[#F956F2] to-[#21DFBD]"></div>
        </div>
      </div>
    </div>
  );
};

export default FullPageLoader;
